const Index = () => import("./index.vue");

export default [
  {
    path: "/billing",
    component: Index,
  },
];
